import { useQuery } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";

export const useAuthQuery = (request, config) => {
  const navigate = useNavigate();
  const axios = useMemo(() => createAxiosWithAuth(), []);
  const queryClient = useQueryClient();

  const response = useQuery({
    queryFn: async () => {
      try {
        const res = await axios(request);
        return res;
      } catch (error) {
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
          queryClient.clear();
          navigate("/login");
          return Promise.reject({ handled: true });
        }
        throw error;
      }
    },
    ...config,
  });

  return response;
};
